const Facilities = ({ facility }) => {
  return (
    <>
      {facility?.map((item, index) => (
        item?.tags && item?.tags.length !== 0 ?
          <div className="col-xl-4" key={index}>
            <div className="row y-gap-30">

              <div className="col-12" key={item?._id}>
                <div>
                  <div className="d-flex items-center text-16 fw-600">
                    <i className={`${item?.name} text-20 mr-10`} />
                    {item?.name}
                  </div>
                  <ul className="text-15 pt-10">
                    {item?.tags?.map((val, i) => (
                      <li className="d-flex items-center" key={i}>
                        {item.name === "What's not included" ? <i className="icon-close text-10 mr-20" style={{ color: "red" }} /> : <i className="icon-check text-10 mr-20" style={{ color: "green" }} />}
                        {val}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

            </div>
          </div> : ""
      ))}
    </>
  );
};

export default Facilities;
